import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { Hero, SocialProof } from './components/Hero';
import { TestimonialsSet1, TestimonialsSet2, Guarantee } from './components/Testimonials';
import { PainPoints, CostTable } from './components/PainPoints';
import { ProductOverview, Tomos, Bonuses } from './components/Product';
import { Urgency, PricingCards, Accelerator, FinalCTA } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { ToastNotification } from './components/ui';
export function App() {
  return <div className="min-h-screen bg-dark-bg text-white font-sans selection:bg-primary/30 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <TestimonialsSet1 data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductOverview data-id="element-6" />
      <Tomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Urgency data-id="element-9" />
      <PricingCards data-id="element-10" />
      <Accelerator data-id="element-11" />
      <TestimonialsSet2 data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <CostTable data-id="element-15" />

      <FinalCTA data-id="element-16" />

      <Footer data-id="element-17" />
      <ToastNotification data-id="element-18" />
      <FloatingWhatsApp data-id="element-19" />
    </div>;
}